const conditions = () => {
  return [{ assetClass: 'object.asset-class.options.kapitalgeber' }, { typeOfFinancing: 'object.type-of-financing.options.senior-loan' }]
}

export default conditions
